export * from '@primeuix/themes/material/panelmenu';
export { default } from '@primeuix/themes/material/panelmenu';
